<template>
  <div class="points">
    <div class="points-header">
      <div class="points-header__rule" @click="onOpenRuleDialog"></div>
      <div class="points-header__record" @click="onRouteExchangeRecord"></div>
    </div>
    <div class="points-content">
      <div class="points-content-header">
        <div class="header__user">
          <span>用户：</span>
          <span>{{ mobile }}</span>
        </div>
        <div class="header__points">
          <span>积分：</span>
          <span>{{ points }}</span>
        </div>
      </div>
      <div class="points-content-btn" @click="onRoutePointsRecord"></div>
      <div class="points-content-inner">
        <img :class="[
          'points-content__item',
          productList.stock === 0 && 'points-content__item--empty'
        ]"
        v-for="product in productList"
        :key="product.id"
        @click="onItemClick(product)"  :src="`${imgPrefix}${product.thumbnailUrl}`" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRef, onMounted } from 'vue'
import { Dialog } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import globalVariables from '@/utils/globalVariables'
import api from '@/api'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()

    const { activityCode } = route.query
    const data = reactive({
      mobile: '',
      points: 0,
      productList: []
    })

    const onItemClick = product => {
      if (product.stock === 0) {
        Dialog.alert({
          message: '该商品已售罄'
        })
        return
      }
      router.push({
        path: '/productDetail',
        query: {
          id: product.id,
          activityCode
        }
      })
    }

    const onRouteExchangeRecord = () => {
      router.push('/exchangeRecord')
    }
    const onOpenRuleDialog = () => {
      router.push({ path:'/picpage', query: { pic: `${globalVariables.imgPrefix}hxsz_point_home.jpg`, title: '活动规则' } })
    }
    const onRoutePointsRecord = () => {
      router.push('/pointsRecord')
    }

    onMounted(() => {
      document.title = ''
      const user = globalVariables.getUserInfo(globalVariables.getProjectCode())
      if (user.customerID !== '-1') {
          data.mobile = user.username
      } else {
          data.mobile = '请先登录'
      }

      api.getPoints({ activityCode }).then(res => {
        data.points = res.data
      })

      api
        .getProductList({
          activityCode
        })
        .then(res => {
          data.productList = res.data
        })

      // 测试代码
      // data.productList = [
      //   {
      //     id: 7,
      //     name: '测试商品7_虚拟卡密类型',
      //     price: 20.0,
      //     stock: 10,
      //     thumbnailUrl: '20220412120729618.png',
      //     headerImgUrl: '20220412120729618.png',
      //     detailImgUrl: '20220412120729618.png',
      //     productType: 4,
      //     description: ''
      //   }
      // ]
    })

    return {
      imgPrefix: globalVariables.imgPrefix,
      mobile: toRef(data, 'mobile'),
      points: toRef(data, 'points'),
      productList: toRef(data, 'productList'),
      onOpenRuleDialog,
      onRouteExchangeRecord,
      onRoutePointsRecord,
      onItemClick
    }
  }
}
</script>

<style lang="less" scoped>
.points {
  min-height: 100vh;
  background-color: #db2d2e;
  padding-bottom: 5px;
  .points-header {
    width: 375px;
    height: 245px;
    background-image: url('../../assets/points-bg.jpg');
    background-repeat: no-repeat;
    background-size: 100%;
    .points-header__rule {
      width: 54px;
      height: 48px;
      background-image: url('../../assets/points-rule-btn.png');
      background-repeat: no-repeat;
      background-size: 100%;
      position:absolute;
      top: 96px;
      left: -8px;
    }
    .points-header__rule:active {
      opacity: 0.8;
    }
    .points-header__record {
      width: 43px;
      height: 51px;
      background-image: url('../../assets/points-record-btn.png');
      background-repeat: no-repeat;
      background-size: 100%;
      position:absolute;
      top:100px;
      right: 0;
    }
    .points-header__record:active {
      opacity: 0.8;
    }
  }
  .points-content {
    margin-top: -58px;
    width: 375px;
    min-height: 450px;
    background-image: url('../../assets/points-content-top.png'),url('../../assets/points-content-bottom.png');
    background-position: top center,  bottom center;
    background-repeat: no-repeat, no-repeat;
    background-size: 100%;
    display: flex;
    .points-content-header {
      position: absolute;
      top: 201px;
      left: 85px;

      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-style: italic;
      color: #FFFFFF; 

      .header__points {
        margin-top: 7px;
      }
    }
    .points-content-btn {
      width: 80px;
      height: 43px;
      background-image: url('../../assets/points-detail-btn.png');
      background-repeat: no-repeat;
      background-size: 100%;
      position:absolute;
      top: 205px;
      right: -6px;
    }
    .points-content-btn:active {
      opacity: 0.8;
    }
    .points-content-inner {
      flex:1;
      background-image: url('../../assets/points-content-mid.png');
      background-position: 0 191px;
      background-repeat: repeat-y;
      background-size: 100%;
      margin-top: 95px;
      margin-bottom: 28px;
      display: flex;
      flex-wrap: wrap;
      padding-left: 18px;
      .points-content__item {
        width: 139px;
        height: 131px;
        margin-left: 20px;
        margin-bottom: 20px;
      }
      .points-content__item--empty {
        filter: grayscale(100%);
      }
    }

  }
  .rule-popup {
    margin: 0 20px;
    font-size: 12px;
  }
}
</style>